export const getSidebarNavLinkClass = (isActive: boolean) => [
  "flex items-center rounded-xl text-sm font-medium transition-all duration-300 pl-2 pr-4 py-2.5",
  isActive
    ? "bg-primary-accent text-white font-semibold shadow-md"
    : "text-text-secondary hover:text-text-primary hover:bg-bg-surface/40",
].join(" ");

export const getSidebarNavIconClass = (isActive: boolean) => [
  "inline-flex items-center justify-center w-8 h-8 rounded-lg text-base shrink-0 transition-colors",
  isActive ? "text-white" : "text-text-secondary",
].join(" ");
